























































import * as CurrentTime from '@/models/current-time/functions'
import {
  RemainingTime,
  remainingUntil,
} from '@spa/components/pages/cart/model/same-day-shipping/same-day-shipping-countdown'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

const TICK_INTERVAL_MS = 1000
const SECONDS_DISPLAY_DIGITS = 2

/**
 * 文言・見え方は新フロント（pj-hotel-lovers-front）の同機能と揃える。片方だけ変えると同じホテラバ内で Web と新フロントの表示がずれる。
 */
@Component
export default class SameDayShippingCountdown extends Vue {
  @Prop({ required: true })
  readonly orderDeadlineAt: Date

  now: Date = CurrentTime.create().now

  timerId: number | null = null

  mounted() {
    this.timerId = window.setInterval(this.tick, TICK_INTERVAL_MS)
  }

  beforeDestroy() {
    this.stopTicking()
  }

  tick(): void {
    const wasCounting = this.remaining !== null
    this.now = CurrentTime.create().now
    if (wasCounting && this.remaining === null) {
      this.stopTicking()
      this.$emit('expired')
    }
  }

  stopTicking(): void {
    if (this.timerId !== null) {
      window.clearInterval(this.timerId)
      this.timerId = null
    }
  }

  get remaining(): RemainingTime | null {
    return remainingUntil(this.orderDeadlineAt, this.now)
  }

  get paddedSeconds(): string {
    const seconds = this.remaining ? this.remaining.seconds : 0

    return `0${seconds}`.slice(-SECONDS_DISPLAY_DIGITS)
  }
}
